import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { fetchAllOffers, saveOffer } from "./offersThunks"
import { Coupon } from "@/types"

interface OffersState {
  offers: Coupon[]
  loading: boolean
  loaded: boolean
  error: string | null
}

const initialState: OffersState = {
  offers: [],
  loading: false,
  loaded: false,
  error: null,
}

const offersSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllOffers.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAllOffers.fulfilled, (state, action: PayloadAction<Coupon[]>) => {
        state.loading = false
        state.loaded = true
        state.offers = action.payload
      })
      .addCase(fetchAllOffers.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || "Failed to fetch offers"
      })
      .addCase(saveOffer.fulfilled, (state, action: PayloadAction<Coupon>) => {
        if (!action.payload.id) {
          return
        }

        const index = state.offers.findIndex(o => o.id === action.payload.id)
        if (index !== -1) {
          state.offers[index] = action.payload
        } else {
          state.offers.push(action.payload)
        }
      })
  },
})

export default offersSlice.reducer
